import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

type VariantType = "expired" | "active" | "expiring";

const isRedVariant = (expiryVariant: VariantType) => expiryVariant === "expired" || expiryVariant === "expiring";

export const GradientWrapper = styled.div<{ expiryVariant: VariantType }>`
  flex: 1;
  border-radius: 12px;
  background: ${(props) =>
    isRedVariant(props.expiryVariant) ? "#FFF6F6" : "#F0F9F4"};
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 7px;
    border-radius: 12px 0 0 12px;
    background: ${(props) =>
      isRedVariant(props.expiryVariant)
        ? "linear-gradient(180deg, #E53E3E 0%, #C53030 50%, #9B2C2C 100%)"
        : "linear-gradient(180deg, #38A169 0%, #2F855A 50%, #276749 100%)"};
  }
`;

export const InnerContainer = styled.div<{ expiryVariant: VariantType }>`
  padding: 16px 8px 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled(Text)`
  font-size: 12px;
  font-weight: 500;
  color: #040222;
  margin: 0;
  line-height: 18px;
`;

export const StatusText = styled(Text)<{ expiryVariant: VariantType }>`
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  color: ${(props) =>
    isRedVariant(props.expiryVariant) ? "#D83D37" : "#34A853"};
  line-height: 18px;
`;
